import script from "./CodeStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeStep.vue?vue&type=script&setup=true&lang=ts"

import "./CodeStep.vue?vue&type=style&index=0&id=561fc2ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561fc2ca"]])

export default __exports__